import React from "react";
import Banner from "../Components/Banner";
import Footer from "../SharedPage/Footer";
import Navbar from "../SharedPage/Navbar";
import Contact from "./Contact";
import Details from "./Details";
import "./Home.css";
import Portfolio from "./Portfolio";

const Home = () => {
  return (
    <div>
      <Navbar />
      <div data-aos-duration="2000" data-aos="zoom-in-up">
        <Banner />
        <div className="w-9/12 mx-auto pb-10">
          <div className="d_container h-full flex lg:flex-row flex-col justify-around">
            <div className="l_side">
              <Details />
            </div>
            <div className="r_side ">
              <Portfolio />
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
